import type { IconSvgObject } from './types';

const AspectRatioIcon: IconSvgObject = [
  ["path", { d: "M20 3H4C2.89543 3 2 3.89543 2 5V19C2 20.1046 2.89543 21 4 21H20C21.1046 21 22 20.1046 22 19V5C22 3.89543 21.1046 3 20 3Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M2 9H14C15.1046 9 16 9.89543 16 11V21", stroke: "currentColor", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M10 21L10 9", stroke: "currentColor", strokeWidth: "1.5", key: "2" }]
];

export default AspectRatioIcon;
